import React, { useState, useEffect } from "react";
import {
  Paper,
  Grid,
  Table,
  FormControl,
  TableHead,
  TableRow,
  TableContainer,
  TableBody,
  TableCell,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";
import Pagination from "@material-ui/lab/Pagination";
import ConfirmDialog from "../common/confirmDialog/ConfirmDialog";
import { makeStyles } from "@material-ui/core/styles";

import ReactSelect from "react-select";
import api from "../../api";
import utils from "../../utils/utils";
import Tooltip from "@material-ui/core/Tooltip";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles({
  paperFullWidth: {
    overflowY: "visible",
    maxWidth: 300,
  },
  dialogContentRoot: {
    overflowY: "visible",
  },
});

export default function PaymentMethodAssign({
  setIsLoading,
  setDataToast,
}) {
  const [dataTable, setDataTable] = useState();
  const [companiesList, setCompaniesList] = useState();
  const [filterData, setFilterData] = useState({
    company: undefined,
    name: undefined,
  });

  const [filterDataNew, setFilterDataNew] = useState({
    company: undefined,
    name: undefined,
  });
  const itemsPerPage = 10;
  const [paginationData, setPaginationData] = useState({
    amount: 0,
    currentPage: 1,
  });
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    id: undefined,
    paymentMethodId: undefined,
    companyId: undefined,
  });
  const [editValues, setEditValues] = useState({
    id: undefined,
    companyId: "",
    sapCode: "",
    externalPaymentMethodId: "",
    paymentMethodId: "",
  });
  const [companiesListEdit, setCompaniesListEdit] = useState([]);
  const [paymentMethodEditList, setpaymentMethodEditList] = useState([]);
  const [articleSapEditList, setArticleSapEditList] = useState([]);
  const [externalPaymentMethodEditList, setExternalPaymentMethodEditList] =
    useState([]);
  const [paymentMethodList, setPaymentMethods] = useState();
  const [articleSapList, setArticleSap] = useState();
  const [externalPaymentMethodList, setExternalPaymentMethodList] = useState();
  const [openEdit, setOpenEdit] = React.useState(false);
  const handleClickEdit = (id) => {
    setEditValues({
      id: undefined,
      companyId: "",
      sapCode: "",
      externalPaymentMethodId: "",
      salesChannelId: "",
    });
    getPaymentMethod(id);
  };
  const handleClickOpen = () => {
    setPaymentMethods(undefined);
    setArticleSap(undefined);
    setExternalPaymentMethodList(undefined);
    validatePaymentMethod();
    setOpen(true);
  };

  const [open, setOpen] = React.useState(false);

  const classes = useStyles();

  useEffect(() => {
    if (!open) {
      setFilterDataNew({
        company: undefined,
        name: undefined,
      });
    }
  }, [open]);

  const onClickCreate = (company) => {
    if (
      company.company !== undefined &&
      company.company.label !== undefined &&
      company.paymentMethod !== null &&
      company.articleSap !== null
    ) {
      if (company.externalPaymentMethod !== null) {
        var body = {
          numeroEstablecimiento: null,
          codigoArticuloSAP: company.articleSap.key,
          numeroMedioPagoExterno: company.externalPaymentMethod.key,
        };
      } else {
        var body = {
          numeroEstablecimiento: null,
          codigoArticuloSAP: company.articleSap.key,
        };
      }

      api
        .postPaymentCompanyMethod(
          company.paymentMethod.value,
          company.company.value,
          body
        )

        .then(() => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: "Medio de pago asignado correctamente.",
            type: "success",
          });

          filterDataNew.company = undefined;
          filterDataNew.name = undefined;
          reloadData(1, 1, itemsPerPage, true);
          setOpen(false);
        })

        .catch((err) => {
          setIsLoading(false);
          setDataToast({
            active: true,
            message: err.response.data.errores ?? "Ocurrió un error.",
            type: "error",
          });
          setOpen(false);
        });
    } else if (
      company.company === undefined ||
      company.company.label === undefined
    ) {
      shortError("Debe seleccionar una compañia");
    } else if (company.paymentMethod === null) {
      shortError("Debe seleccionar un medio de pago");
    } else if (company.articleSap === null) {
      shortError("Debe seleccionar artículo SAP");
    }
  };

  function search(e) {
    e.preventDefault();
    reloadData(1, 1, itemsPerPage, true);
  }

  const changePage = (event, value) => {
    let from = (value - 1) * itemsPerPage + 1;
    let to = value * itemsPerPage;

    reloadData(value, from, to, false);
  };

  function reloadData(page, from, to, reloadPages) {
    setIsLoading(true);

    api
      .getPaymentMethodCompany(
        filterData.company,
        filterData.name,
        from,
        to,
        reloadPages
      )
      .then((res) => {
        let data = res.data.paymentMethodsCompanies;
        let currentPage = page;
        let amount = paginationData.amount;

        if (reloadPages) {
          if (currentPage !== 1) currentPage = 1;
          amount = Math.ceil(res.data.cantidad / itemsPerPage);
        }

        setPaginationData({
          amount: amount,
          currentPage: currentPage,
        });

        let list = [];
        data.forEach((item) => {
          list.push({
            id: item.medioDePagoCompaniaId,
            paymentMethod: item.nombreMedioDePago,
            company: item.nombre,
            companyId: item.companiaId,
            paymentMethodId: item.medioDePagoId,
            articleSapId: item.codigoArticuloSap,
            articleSapName: item.nombreArticuloSap,
            externalPaymentMethodId:
              item.medioDePagoExterno.codigoMedioDePagoExterno,
            externalPaymentMethod:
              item.medioDePagoExterno.nombreMedioDePagoExterno,
          });
        });

        setDataTable(list);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          type: "error",
          message: "Ocurrió un error.",
        });
      });
  }

  function closePreDelete() {
    setDeleteDialog({ ...deleteDialog, open: false });
  }

  function preDelete(id, companyId, paymentMethodId) {
    setDeleteDialog({
      open: true,
      id: id,
      companyId: companyId,
      paymentMethodId: paymentMethodId,
    });
  }

  function deletePaymentMethodCompany(id, companyId, paymentMethodId) {
    closePreDelete();
    setIsLoading(true);
    api
      .deletePaymentMethodCompany(companyId, paymentMethodId)
      .then((res) => {
        let newDataTable = [];
        dataTable.forEach((paymentMethod) => {
          if (paymentMethod.id !== id) {
            newDataTable.push(paymentMethod);
          }
        });

        setDataTable(newDataTable);
        setIsLoading(false);
        utils.alertSuccess(
          "Medio de Pago asociado a Compañía N° " + id,
          "Eliminado correctamente."
        );
      })
      .catch((err) => {
        setIsLoading(false);
        if (Array.isArray(err.response.data.errores)) {
          err.response.data.errores.map((m) => {
            utils.alertError("Medio de pago asociado a compañia N° " + id, m);
          });
        } else {
          shortError("Ocurrió un error");
        }
      });
  }

  const getPaymentMethod = (id) => {
    setIsLoading(true);
    var paymentsMethodAssign = 1;
    api
      .getExternalPaymentMethodById(id)
      .then((res) => {
        setEditValues({
          ...editValues,
          id: res.data.medioDePagoCompaniaId,
          companyId: res.data.companiaId,
          sapCode: res.data.codigoArticuloSap,
          externalPaymentMethodId:
            res.data.medioDePagoExterno.codigoMedioDePagoExterno,
          paymentMethodId: res.data.medioDePagoId,
        });
        api.getCompanies().then((res1) => {
          res1.data = utils.refactorDataInList(res1.data, res.data.companiaId);
          setCompaniesListEdit(utils.setDataInSearchList(res1.data));
        });
        api
          .getListNamePaymentMethods(res.data.companiaId, paymentsMethodAssign)
          .then((res2) => {
            res2.data = utils.refactorDataInList(
              res2.data,
              res.data.medioDePagoId
            );
            setpaymentMethodEditList(utils.setDataInSearchList(res2.data));
          });
        api.getArticleSelectList().then((res3) => {
          setArticleSapEditList(utils.setDataInListSap(res3.data));
        });
        api.getExternalPaymentMethod().then((res4) => {
          setExternalPaymentMethodEditList(
            utils.setDataInSearchList(res4.data)
          );
        });
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  };

  const onClickEdit = () => {
    setIsLoading(true);
    if (true) {
      var id = editValues.id;
      var paymentMethodCompanyRequest = {
        codigoArticuloSAP: editValues.sapCode,
        numeroMedioPagoExterno: editValues.externalPaymentMethodId,
      };
      var body = {
        medioDePagoid: editValues.paymentMethodId,
        companiaId: editValues.companyId,
        paymentMethodCompanyRequest: paymentMethodCompanyRequest,
      };
    }
    api
      .putExternalPaymentMethodById(id, body)
      .then((res) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          message: "Medio de pago editado correctamente.",
          type: "success",
        });
        reloadData(1, 1, itemsPerPage, true);
      })
      .catch((err) => {
        setIsLoading(false);
        setDataToast({
          active: true,
          message: err.response.data.errores ?? "Ocurrió un error.",
          type: "error",
        });
      });
    setEditValues({
      id: undefined,
      companyId: "",
      sapCode: "",
      externalPaymentMethodId: "",
      salesChannelId: "",
    });
    setArticleSapEditList();
    setExternalPaymentMethodEditList();
    setOpenEdit(false);
  };

  function shortError(message) {
    setDataToast({
      active: true,
      message: message,
      type: "error",
    });
  }

  function validatePaymentMethod() {
    let response = false;
    if (!filterDataNew.company) response = true;

    return response;
  }

  function handleChangeCompany(e) {
    setFilterDataNew({
      ...filterDataNew,
      paymentMethod: null,
      company: e,
      articleSap: null,
      externalPaymentMethod: null,
    });

    var paymentsMethodAssign = 0;
    Promise.all([
      api
        .getListNamePaymentMethods(e.value, paymentsMethodAssign)
        .then((res) => setPaymentMethods(utils.setDataInSearchList(res.data))),
      api
        .getArticleSelectList()
        .then((res) => setArticleSap(utils.setDataInListSap(res.data))),
      api
        .getExternalPaymentMethod()
        .then((res) =>
          setExternalPaymentMethodList(utils.setDataInSearchList(res.data))
        ),
    ])
      .then(() => setIsLoading(false))
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  }

  useEffect(() => {
    setIsLoading(true);

    Promise.all([
      api
        .getCompanies()
        .then((res) => setCompaniesList(utils.setDataInSearchList(res.data))),
    ])
      .then(() => setIsLoading(false))
      .catch((err) => {
        setIsLoading(false);
        shortError("Ocurrió un error");
      });
  }, []);

  const handleChangePayment = (event) => {
    setFilterDataNew({
      ...filterDataNew,
      paymentMethod: event,
    });
  };

  const handleChangeArticleSAP = (event) => {
    setFilterDataNew({
      ...filterDataNew,
      articleSap: event,
    });
  };

  const handleChangeExternalPaymentMethod = (event) => {
    setFilterDataNew({
      ...filterDataNew,
      externalPaymentMethod: event,
    });
  };
  const handleChangeArticleSAPEdit = (event) => {
    setEditValues({
      ...editValues,
      sapCode: event.key,
    });
  };

  const handleChangeExternalPaymentMethodEdit = (event) => {
    setEditValues({
      ...editValues,
      externalPaymentMethodId: event?.key,
    });
  };
  return (
    <>
      <Paper className="c-grid" elevation={3}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid className="c-grid-header" container spacing={1}>
              <Grid item xs={6}>
                <h2>ASIGNAR MEDIO DE PAGO A COMPAÑIA</h2>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  className="c-grid-btn c-btn-success"
                  color="primary"
                  onClick={() => handleClickOpen()}
                >
                  Asignar Nuevo
                </Button>

                <Dialog
                  open={open}
                  onClose={() => setOpen(false)}
                  aria-labelledby="form-dialog-title"
                  fullWidth={true}
                  classes={{
                    paperFullWidth: classes.paperFullWidth,
                  }}
                >
                  <DialogTitle id="form-dialog-title">
                    Asignar Nuevo
                  </DialogTitle>
                  <DialogContent
                    classes={{
                      root: classes.dialogContentRoot,
                    }}
                    style={{ maxWidth: 300, marginTop: 15 }}
                  >
                    <ReactSelect
                      placeholder="Buscar compañias..."
                      name="company"
                      onChange={(e) => handleChangeCompany(e)}
                      options={companiesList}
                      value={filterDataNew?.company}
                      required
                    />
                    <span>&nbsp;&nbsp;</span>
                    <ReactSelect
                      isDisabled={!filterDataNew?.company}
                      placeholder="Buscar medios de pago..."
                      name="paymentMethod"
                      onChange={(e) => {
                        handleChangePayment(e);
                      }}
                      value={filterDataNew?.paymentMethod ?? null}
                      options={paymentMethodList}
                      isClearable={true}
                      required
                    />
                    <span>&nbsp;&nbsp;</span>
                    <ReactSelect
                      isDisabled={!filterDataNew?.company}
                      placeholder="Buscar artículo SAP..."
                      name="articleSAP"
                      onChange={(e) => {
                        handleChangeArticleSAP(e);
                      }}
                      value={filterDataNew?.articleSap}
                      options={articleSapList}
                      isClearable={true}
                      required
                    />
                    <span>&nbsp;&nbsp;</span>
                    <ReactSelect
                      isDisabled={!filterDataNew?.company}
                      placeholder="Buscar medio de pago externo..."
                      name="externalPaymentMethod"
                      onChange={(e) => {
                        handleChangeExternalPaymentMethod(e);
                      }}
                      value={filterDataNew?.externalPaymentMethod}
                      options={externalPaymentMethodList}
                      isClearable={true}
                    />
                  </DialogContent>

                  <DialogActions>
                    <Button
                      onClick={() => setOpen(false)}
                      className="c-btn-cancel"
                    >
                      Cancelar
                    </Button>
                    <Button
                      onClick={() => onClickCreate(filterDataNew)}
                      className="c-btn-success"
                    >
                      Aceptar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Grid>
            </Grid>
          </Grid>

          <Grid className="c-grid-header-filter c-mt-10" item xs={12}>
            <form onSubmit={search}>
              <Grid container spacing={1}>
                <Grid item md={3} xs={12}>
                  <FormControl variant="outlined" fullWidth={true} size="small">
                    <ReactSelect
                      placeholder="Buscar compañias..."
                      name="company"
                      onChange={(e) => {
                        setFilterData({
                          ...filterData,
                          company: e ? e.value : undefined,
                        });
                      }}
                      options={companiesList}
                      isClearable={true}
                      required
                    />
                  </FormControl>
                </Grid>
                <Grid item md={2} xs={12}>
                  <Button
                    className="c-btn-info c-mt-2"
                    variant="contained"
                    fullWidth={true}
                    type="submit"
                    startIcon={<SearchIcon />}
                  >
                    Buscar
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Paper>

      {dataTable && dataTable.length > 0 && (
        <Paper className="c-mt-20 c-grid-results" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TableContainer>
                <Table className="c-table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell className="c-w-30">Compañia</TableCell>
                      <TableCell className="c-w-20">Medio de Pago</TableCell>
                      <TableCell className="c-w-20">
                        Medio de Pago Externo
                      </TableCell>
                      <TableCell className="c-w-30">Artículo SAP</TableCell>
                      <TableCell className="c-w-10">Opciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {dataTable.map(
                      ({
                        id,
                        company,
                        paymentMethod,
                        companyId,
                        paymentMethodId,
                        articleSapId,
                        articleSapName,
                        externalPaymentMethodId,
                        externalPaymentMethod,
                      }) => (
                        <TableRow key={id}>
                          <TableCell className="c-w-30">{company}</TableCell>
                          <TableCell className="c-w-30">
                            {paymentMethod}
                          </TableCell>
                          <TableCell>{externalPaymentMethod}</TableCell>
                          <TableCell>{articleSapName}</TableCell>
                          <TableCell className="c-w-20">
                            <Tooltip title="Editar" arrow>
                              <IconButton
                                className="c-grid-btn-edit button-grid"
                                onClick={() => {
                                  handleClickEdit(id);
                                  setOpenEdit(true);
                                }}
                              >
                                <CreateIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Dar de baja" arrow>
                              <IconButton
                                className="c-grid-btn-cancel button-grid"
                                onClick={() =>
                                  preDelete(id, companyId, paymentMethodId)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>
                          </TableCell>
                        </TableRow>
                      )
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            <Grid
              item
              xs={12}
              container
              direction="column"
              alignItems="center"
              justify="center"
            >
              <Pagination
                className="c-pagination"
                onChange={changePage}
                page={paginationData.currentPage}
                count={paginationData.amount > 1 ? paginationData.amount : 0}
                shape="rounded"
              />
            </Grid>
          </Grid>
        </Paper>
      )}

      {dataTable && dataTable.length === 0 && (
        <Paper className="c-mt-20" elevation={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} className="c-text-center">
              <h5>No se encontraron resultados.</h5>
            </Grid>
          </Grid>
        </Paper>
      )}

      {deleteDialog !== undefined && (
        <ConfirmDialog
          open={deleteDialog.open}
          message={
            "¿Desea eliminar el Medio de Pago N° " + deleteDialog.id + " ?"
          }
          cancelAction={closePreDelete}
          confirmAction={() =>
            deletePaymentMethodCompany(
              deleteDialog.id,
              deleteDialog.companyId,
              deleteDialog.paymentMethodId
            )
          }
        />
      )}
      {openEdit && (
        <Dialog
          open={openEdit}
          onClose={() => setOpenEdit(false)}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          classes={{
            paperFullWidth: classes.paperFullWidth,
          }}
        >
          <DialogTitle id="form-dialog-title">Asignar Nuevo</DialogTitle>
          <DialogContent
            classes={{
              root: classes.dialogContentRoot,
            }}
            style={{ maxWidth: 300, marginTop: 15 }}
          >
            <ReactSelect
              placeholder="Buscar compañias..."
              name="companyEdit"
              options={companiesListEdit}
              value={companiesListEdit[0]}
              required
              isDisabled
            />
            <span>&nbsp;&nbsp;</span>
            <ReactSelect
              placeholder="Buscar medios de pago..."
              name="paymentMethodEdit"
              options={paymentMethodEditList}
              value={paymentMethodEditList[0]}
              isClearable={true}
              required
              isDisabled
            />
            <span>&nbsp;&nbsp;</span>
            <ReactSelect
              placeholder="Buscar artículo SAP..."
              name="articleSAPEdit"
              onChange={(e) => {
                handleChangeArticleSAPEdit(e);
              }}
              options={articleSapEditList}
              value={articleSapEditList?.filter(
                (option) => option.key === editValues.sapCode
              )}
              required
            />
            <span>&nbsp;&nbsp;</span>
            <ReactSelect
              placeholder="Buscar medio de pago externo..."
              name="externalPaymentMethodEdit"
              onChange={(e) => {
                handleChangeExternalPaymentMethodEdit(e);
              }}
              value={externalPaymentMethodEditList?.filter(
                (option) => option.key === editValues.externalPaymentMethodId
              )}
              options={externalPaymentMethodEditList}
              isClearable={true}
            />
          </DialogContent>

          <DialogActions>
            <Button onClick={() => setOpenEdit(false)} className="c-btn-cancel">
              Cancelar
            </Button>
            <Button onClick={() => onClickEdit()} className="c-btn-success">
              Aceptar
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}
